// import React, { useState, useEffect, useCallback } from "react";
// import axios from "axios";
// import toast from "react-hot-toast";
// import { useAuth } from "../context/AuthContext";
// import UploadZone from "../components/UploadZone";
// import InvoiceGrid from "../components/InvoiceGrid";
// import UsersPage from "./UsersPage";
// import InvoiceHistory from "./InvoiceHistory";

// export default function Dashboard() {
//   const { user, logout, hasPermission } = useAuth();
//   const [invoices, setInvoices] = useState([]);
//   const [loading, setLoading]   = useState(true);
//   const [tab, setTab] = useState("grid");
//   const [sidebarOpen, setSidebarOpen] = useState(false);

//   const fetchInvoices = useCallback(async () => {
//     setLoading(true);
//     try {
//       const res = await axios.get("/api/invoices");
//       setInvoices(res.data);
//     } catch {
//       toast.error("Failed to load invoices");
//     } finally {
//       setLoading(false);
//     }
//   }, []);

//   useEffect(() => { fetchInvoices(); }, [fetchInvoices]);

//   const handleUploaded = () => { fetchInvoices(); setTab("grid"); };
//   const handleDeleted  = (ids) => setInvoices(prev => prev.filter(r => !ids.includes(r.id)));
//   const handleUpdated  = (updated) => setInvoices(prev => prev.map(r => r.id === updated.id ? { ...r, ...updated } : r));

//   const selectTab = (key) => { setTab(key); setSidebarOpen(false); };

//   const stats = {
//     total:   invoices.length,
//     sellers: new Set(invoices.map(r => r.seller_name).filter(Boolean)).size,
//     today:   invoices.filter(r => r.created_at?.startsWith(new Date().toISOString().slice(0, 10))).length,
//   };

//   const navItems = [
//     ...(hasPermission("upload_invoice") ? [{ key: "upload", icon: "⬆", label: "Upload" }] : []),
//     { key: "grid",   icon: "☰", label: "Invoices", badge: invoices.length },
//     ...(user?.role === "admin" ? [{ key: "users", icon: "👥", label: "Users" }] : []),
//   ];

//   const titles = { upload: "Upload Invoices", grid: "Invoice Records", users: "User Management", history: "Invoice History" };
//   const subs   = {
//     upload: "Drag & drop PDF invoices for AI extraction",
//     grid:   "Most recent invoices",
//     users:  "Manage portal users",
//     history: "Search and browse all extracted invoices",
//   };

//   return (
//     <div className="dashboard">
//       {sidebarOpen && <div className="sidebar-backdrop" onClick={() => setSidebarOpen(false)} />}

//       <aside className={`sidebar ${sidebarOpen ? "open" : ""}`}>
//         <div className="sidebar-logo">
//           <svg width="32" height="32" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
//             <rect width="48" height="48" rx="10" fill="#e94560"/>
//             <rect x="11" y="7" width="26" height="34" rx="3" fill="white" opacity=".15"/>
//             <rect x="11" y="7" width="26" height="34" rx="3" stroke="white" strokeWidth="1.5"/>
//             <path d="M30 7 L37 14 L30 14 Z" fill="#e94560" stroke="white" strokeWidth="1"/>
//             <rect x="15" y="18" width="12" height="2.5" rx="1.25" fill="white" opacity=".95"/>
//             <rect x="15" y="23" width="18" height="1.5" rx=".75" fill="white" opacity=".6"/>
//             <rect x="15" y="27" width="14" height="1.5" rx=".75" fill="white" opacity=".6"/>
//             <rect x="15" y="31" width="16" height="1.5" rx=".75" fill="white" opacity=".6"/>
//             <rect x="27" y="35" width="8" height="3" rx="1.5" fill="white" opacity=".9"/>
//           </svg>
//           <span>InvoiceExtractor</span>
//           <button className="sidebar-close-btn" onClick={() => setSidebarOpen(false)} aria-label="Close menu">×</button>
//         </div>

//         <nav className="sidebar-nav">
//           {navItems.map(n => (
//             <button key={n.key} className={`nav-item ${tab === n.key ? "active" : ""}`} onClick={() => selectTab(n.key)}>
//               <span className="nav-icon">{n.icon}</span>
//               {n.label}
//               {n.badge > 0 && <span className="nav-badge">{n.badge}</span>}
//             </button>
//           ))}
//         </nav>

//         <div className="sidebar-stats">
//           <div className="stat-item"><span>{stats.total}</span><label>Total</label></div>
//           <div className="stat-item"><span>{stats.sellers}</span><label>Sellers</label></div>
//           <div className="stat-item"><span>{stats.today}</span><label>Today</label></div>
//         </div>

//         <div className="sidebar-footer">
//           <div className="user-info">
//             <div className="user-avatar">{user?.username?.[0]?.toUpperCase()}</div>
//             <div>
//               <p className="user-name">{user?.username}</p>
//               <p className="user-role">{user?.role}</p>
//             </div>
//           </div>
//           <button className="btn-logout" onClick={logout}>Sign out</button>
//         </div>
//       </aside>

//       <main className="main-content">
//         <header className="page-header">
//           <div className="page-header-title">
//             <button className="mobile-menu-btn" onClick={() => setSidebarOpen(true)} aria-label="Open menu">☰</button>
//             <div>
//               <h2>{titles[tab]}</h2>
//               <p>{subs[tab]}</p>
//             </div>
//           </div>
//             {tab === "grid" && (
//               <div style={{ display: "flex", gap: 10 }}>
//                 <button className="btn-outline" onClick={() => setTab("history")}>
//                   🕘 History
//                 </button>
//                 {hasPermission("upload_invoice") && (
//                   <button
//                     className="btn-primary"
//                     onClick={() => setTab("upload")}
//                   >
//                     + Upload New
//                   </button>
//                 )}
//               </div>
//             )}
//         </header>
//         {tab === "upload" && <UploadZone onUploaded={handleUploaded} />}
//         {tab === "users"  && <UsersPage />}
//         {tab === "grid"   && (
//           loading
//             ? <div className="loading-state"><div className="spinner" /><p>Loading…</p></div>
//             : <InvoiceGrid rows={invoices} onDeleted={handleDeleted} onUpdated={handleUpdated} limit={10} grouped={false} />
//         )}
//         {tab === "history" && (
//           loading
//             ? <div className="loading-state"><div className="spinner" /><p>Loading…</p></div>
//             : (
//               <InvoiceHistory
//                 rows={invoices}
//                 onDeleted={handleDeleted}
//                 onUpdated={handleUpdated}
//                 onBack={() => setTab("grid")}
//               />
//             )
//         )}
//       </main>
//     </div>
//   );
// }











import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import toast from "react-hot-toast";
import { useAuth } from "../context/AuthContext";
import UploadZone from "../components/UploadZone";
import InvoiceGrid from "../components/InvoiceGrid";
import UsersPage from "./UsersPage";
import InvoiceHistory from "./InvoiceHistory";

export default function Dashboard() {
  const { user, logout, hasPermission } = useAuth();
  const [invoices, setInvoices] = useState([]);
  const [loading, setLoading]   = useState(true);
  const [tab, setTab] = useState(user?.viaBypass ? "upload" : "grid");
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const fetchInvoices = useCallback(async () => {
    setLoading(true);
    try {
      const res = await axios.get("/api/invoices");
      setInvoices(res.data);
    } catch {
      toast.error("Failed to load invoices");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { fetchInvoices(); }, [fetchInvoices]);

  const handleUploaded = () => { fetchInvoices(); setTab("grid"); };
  const handleDeleted  = (ids) => setInvoices(prev => prev.filter(r => !ids.includes(r.id)));
  const handleUpdated  = (updated) => setInvoices(prev => prev.map(r => r.id === updated.id ? { ...r, ...updated } : r));

  const selectTab = (key) => { setTab(key); setSidebarOpen(false); };

  const stats = {
    total:   invoices.length,
    sellers: new Set(invoices.map(r => r.seller_name).filter(Boolean)).size,
    today:   invoices.filter(r => r.created_at?.startsWith(new Date().toISOString().slice(0, 10))).length,
  };

  const navItems = [
    ...(hasPermission("upload_invoice") ? [{ key: "upload", icon: "⬆", label: "Upload" }] : []),
    { key: "grid",   icon: "☰", label: "Invoices", badge: invoices.length },
    ...(user?.role === "admin" && !user?.viaBypass ? [{ key: "users", icon: "👥", label: "Users" }] : []),
  ];

  const titles = { upload: "Upload Invoices", grid: "Invoice Records", users: "User Management", history: "Invoice History" };
  const subs   = {
    upload: "Drag & drop PDF invoices for AI extraction",
    grid:   "Most recent invoices",
    users:  "Manage portal users",
    history: "Search and browse all extracted invoices",
  };

  return (
    <div className="dashboard">
      {sidebarOpen && <div className="sidebar-backdrop" onClick={() => setSidebarOpen(false)} />}

      <aside className={`sidebar ${sidebarOpen ? "open" : ""}`}>
        <div className="sidebar-logo">
          <svg width="32" height="32" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="48" height="48" rx="10" fill="#e94560"/>
            <rect x="11" y="7" width="26" height="34" rx="3" fill="white" opacity=".15"/>
            <rect x="11" y="7" width="26" height="34" rx="3" stroke="white" strokeWidth="1.5"/>
            <path d="M30 7 L37 14 L30 14 Z" fill="#e94560" stroke="white" strokeWidth="1"/>
            <rect x="15" y="18" width="12" height="2.5" rx="1.25" fill="white" opacity=".95"/>
            <rect x="15" y="23" width="18" height="1.5" rx=".75" fill="white" opacity=".6"/>
            <rect x="15" y="27" width="14" height="1.5" rx=".75" fill="white" opacity=".6"/>
            <rect x="15" y="31" width="16" height="1.5" rx=".75" fill="white" opacity=".6"/>
            <rect x="27" y="35" width="8" height="3" rx="1.5" fill="white" opacity=".9"/>
          </svg>
          <span>InvoiceExtractor</span>
          <button className="sidebar-close-btn" onClick={() => setSidebarOpen(false)} aria-label="Close menu">×</button>
        </div>

        <nav className="sidebar-nav">
          {navItems.map(n => (
            <button key={n.key} className={`nav-item ${tab === n.key ? "active" : ""}`} onClick={() => selectTab(n.key)}>
              <span className="nav-icon">{n.icon}</span>
              {n.label}
              {n.badge > 0 && <span className="nav-badge">{n.badge}</span>}
            </button>
          ))}
        </nav>

        <div className="sidebar-stats">
          <div className="stat-item"><span>{stats.total}</span><label>Total</label></div>
          <div className="stat-item"><span>{stats.sellers}</span><label>Sellers</label></div>
          <div className="stat-item"><span>{stats.today}</span><label>Today</label></div>
        </div>

        <div className="sidebar-footer">
          <div className="user-info">
            <div className="user-avatar">{user?.username?.[0]?.toUpperCase()}</div>
            <div>
              <p className="user-name">{user?.username}</p>
              <p className="user-role">{user?.role}</p>
            </div>
          </div>
          {!user?.viaBypass && (
            <button className="btn-logout" onClick={logout}>Sign out</button>
          )}
        </div>
      </aside>

      <main className="main-content">
        <header className="page-header">
          <div className="page-header-title">
            <button className="mobile-menu-btn" onClick={() => setSidebarOpen(true)} aria-label="Open menu">☰</button>
            <div>
              <h2>{titles[tab]}</h2>
              <p>{subs[tab]}</p>
            </div>
          </div>
            {tab === "grid" && (
              <div style={{ display: "flex", gap: 10 }}>
                <button className="btn-outline" onClick={() => setTab("history")}>
                  🕘 History
                </button>
                {hasPermission("upload_invoice") && (
                  <button
                    className="btn-primary"
                    onClick={() => setTab("upload")}
                  >
                    + Upload New
                  </button>
                )}
              </div>
            )}
        </header>
        {tab === "upload" && <UploadZone onUploaded={handleUploaded} />}
        {tab === "users"  && <UsersPage />}
        {tab === "grid"   && (
          loading
            ? <div className="loading-state"><div className="spinner" /><p>Loading…</p></div>
            : <InvoiceGrid rows={invoices} onDeleted={handleDeleted} onUpdated={handleUpdated} limit={10} grouped={false} />
        )}
        {tab === "history" && (
          loading
            ? <div className="loading-state"><div className="spinner" /><p>Loading…</p></div>
            : (
              <InvoiceHistory
                rows={invoices}
                onDeleted={handleDeleted}
                onUpdated={handleUpdated}
                onBack={() => setTab("grid")}
              />
            )
        )}
      </main>
    </div>
  );
}